
































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../lib/ajax';
import AbpBase from '../../../../../lib/abpbase';
import QuickTable from "../../../../../components/table/table.vue";
import Tools from '../../../../../lib/tools';
@Component({
	name:'safetyAccidentStatistics',
	components: {
		QuickTable
	}
})
export default class SafetyAccidentStatistics extends AbpBase {
	initData:any = {
		showModal: false,
		formLoading: false,
		accidents: [],			// 事故前20条数据
		organizations: [],
		sexData: [],
		formData: {
			id: '',
			accidentDepId: '',
			casualty: '',
			casualtySex: 0,
			casualtyOld: 18,
			kindOfWork: '',
			workingYears: null,
			accidentReportId: '',
			accidentReasonAnalysis: ''
		},
		validate: {
			casualty: [
				{ required: true, message: '请填写伤亡者姓名', trigger: 'blur' }
			],
			accidentReportId: [
				{ required: true, type: 'number', message: '请选择安全生产事故', trigger: 'change' }
			],
			casualtySex: [
				{ required: true, type: 'number', message: '请选择性别', trigger: 'change' }
			],
			accidentDepId: [
				{ required: true, type: 'number', message: '请选择部门', trigger: 'change' }
			]
		},
		columns: [
			{
				title: '序号',
				type: 'index',
				width: 60
			},
			{
				title: '部门',
				key: 'accidentDep',
				render: (h:any, params:any) => {
					return h('span', params.row.accidentDep ? params.row.accidentDep.displayName : '');
				}
			},
			{
				title: '伤亡者姓名',
				key: 'casualty'
			},
			{
				title: '性别',
				key: 'casualtySexDesc'
			},
			{
				title: '年龄',
				key: 'casualtyOld'
			},
			{
				title: '工种',
				key: 'kindOfWork'
			},
			{
				title: '工龄',
				key: 'workingYears'
			},
			{
				title: '事故简况',
				key: 'accidentSummary',
				render: (h:any, params:any) => {
					return h('span', params.row.accidentReport ? params.row.accidentReport.accidentSummary : '');
				}
			},
			{
				title: '事故分析',
				key: 'accidentReasonAnalysis',
				render: (h:any, params:any) => {
					return h('span', params.row.accidentReport ? params.row.accidentReport.accidentReasonAnalysis : '');
				}
			},
			{
				title: '事故损失',
				key: 'accidentLoss',
				render: (h:any, params:any) => {
					return h('span', params.row.accidentReport ? params.row.accidentReport.accidentLoss : '');
				}
			},
			{
				title: '事故类别',
				key: 'accidentType',
				render: (h:any, params:any) => {
					return h('span', params.row.accidentReport ? params.row.accidentReport.accidentType : '');
				}
			},
			{
				title: '事故责任人',
				key: 'accidentLeader',
				render: (h:any, params:any) => {
					return h('span', params.row.accidentReport ? params.row.accidentReport.accidentLeader : '');
				}
			},
			{
				title: '操作',
				key: 'action',
				width: 128,
				render: (h:any, params:any) => {
					return h('div', [
						h('Button', {
							props: {
								type: 'success',
								size: 'small'
							},
							on: {
								click: () => {
									for(let k in this.initData.formData) {
										this.initData.formData[k] = (typeof params.row[k] === 'boolean' ? params.row[k].toString() : params.row[k]);
									}
									this.initData.showModal = true;
								}
							}
						}, '编辑'),
						h('Button', {
							props: {
								type: 'error',
								size: 'small'
							},
							style: {
								marginLeft: '10px'
							},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
						}, '删除')
					])
				}
			}
		]
	}
	init() {
		// 获取部门信息
    	this.$store.dispatch('project/GetbearerOrg').then(() => {
    		this.initData.organizations = this.$store.state.project.bearerOrgId;
    	})
    	
    	// 查询数据字典
    	this.$store.dispatch('project/GetAllDictionary').then(() => {
    		// 性别
    		this.initData.sexData = this.$store.state.project.allDictionary[7].items.map((item:any) => {
    			return {
    				label: item.displayName,
    				value: item.id
    			}
    		});
    	})
    	
		Ajax.get('/api/services/app/SafetyProduct/GetAccidentReportAsync', {params: {MaxResultCount: 20}}).then((res:any)=>{
            this.initData.accidents = res.data.result.items.map((item:any) => {
            	return {
            		value: item.id,
            		label: item.accidentSummary
            	}
            })
        })
	}
    // 新增记录
    async handleSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
          		let datas:any = this.initData.formData;
          		let params:any = {};
          		for(let k in this.initData.formData) {
					if(k !== 'id') {
						params[k] = datas[k];
					}
				}
            	this.initData.formLoading = true;
            	if(datas.id) {
            		params.id = datas.id;
            		await Ajax.put('/api/services/app/SafetyProduct/UpdateAccidentStatisticAsync', params).then((res:any)=>{
		                this.$Message.success('修改成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}else{
            		await Ajax.post('/api/services/app/SafetyProduct/CreateAccidentStatisticAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.formLoading = false;
		                this.initData.showModal = false;
	                	(this as any).$refs.table.GetData();
		            }).catch(() => {
		            	this.initData.formLoading = false;
		            })
            	}
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		this.initData.formData.id = '';
    		(this as any).$refs.form.resetFields();
    	}
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此生产安全事故统计？',
            onOk: () => {
                Ajax.delete('/api/services/app/SafetyProduct/DeleteAccidentStatisticAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	(this as any).$refs.table.GetData();
	            })
            }
        });
    }
    mounted() {
    	this.init();
    }
}
